
import React from 'react';
import { Building, Scale, Globe, ChartLine } from 'lucide-react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface AccountDetailsProps {
  brokerOrPropFirm?: string;
  volumeMultiplier?: string;
  apiStatus?: string;
  addedDate?: string;
  createdAt: string;
}

export const AccountDetails = ({ 
  brokerOrPropFirm,
  volumeMultiplier = '1.0',
  apiStatus = 'Unknown',
  addedDate,
  createdAt
}: AccountDetailsProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="grid grid-cols-2 gap-x-2 gap-y-3 text-sm">
      {brokerOrPropFirm && (
        <>
          <div className="text-muted-foreground flex items-center">
            <Building size={14} className="mr-1.5" />
            <span>{t('broker_prop_firm')}:</span>
          </div>
          <div className="font-medium">{brokerOrPropFirm}</div>
        </>
      )}
      
      <div className="text-muted-foreground flex items-center">
        <Scale size={14} className="mr-1.5" />
        <span>{t('volume_multiplier')}:</span>
      </div>
      <div className="font-medium">{volumeMultiplier}</div>
      
      <div className="text-muted-foreground flex items-center">
        <Globe size={14} className="mr-1.5" />
        <span>{t('platform')}:</span>
      </div>
      <div className="font-medium">CTrader</div>
      
      <div className="text-muted-foreground flex items-center">
        <ChartLine size={14} className="mr-1.5" />
        <span>{t('status')}:</span>
      </div>
      <div className="font-medium">{apiStatus}</div>
      
      <div className="text-muted-foreground flex items-center">
        <span>{t('added')}:</span>
      </div>
      <div className="font-medium">
        {addedDate ? 
          format(new Date(addedDate), 'MMM d, yyyy') : 
          format(new Date(createdAt), 'MMM d, yyyy')
        }
      </div>
    </div>
  );
};
